/* The bag drawer (The Poster Club's, measured 2026-09-26). "Add to bag" no longer leaves the page: the item
   goes in through /cart/add.js, the drawer section comes back rendered in the same response (Section Rendering
   API), and the drawer slides in from the right. The bag icon in the header opens it too. Quantity, remove and
   the "Pair With" + all work in place. Without JS the form still posts to /cart, so nothing breaks. */
(() => {
  const cd = document.querySelector('[data-cd]');
  const body = cd && cd.querySelector('[data-cd-body]');
  if (!cd || !body) return;
  const SECTION = 'cart-drawer';
  let closing = null;

  const setCount = (n) => {
    document.querySelectorAll('.site-head__bag').forEach((a) => {
      a.setAttribute('aria-label', `Bag, ${n} items`);
      const s = a.querySelector('span'); if (s) s.textContent = `(${n})`;
    });
  };
  const render = (html) => {
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const shell = doc.querySelector('.cd__shell');
    const now = body.querySelector('.cd__shell');
    if (shell && now) now.replaceWith(shell);
    const c = body.querySelector('[data-cd-count]');
    if (c) setCount(c.dataset.cdCount);
  };
  const open = () => {
    clearTimeout(closing); cd.classList.remove('is-closing');
    cd.classList.add('is-open'); cd.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-lock');
    const x = cd.querySelector('[data-cd-close].cd__close'); if (x) x.focus({ preventScroll: true });
  };
  const close = () => {
    if (!cd.classList.contains('is-open')) return;
    cd.classList.remove('is-open'); cd.classList.add('is-closing'); cd.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-lock');
    closing = setTimeout(() => cd.classList.remove('is-closing'), 700);
  };
  const post = (url, payload) => fetch(url, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ ...payload, sections: SECTION, sections_url: location.pathname }),
  }).then((r) => r.json().then((j) => { if (!r.ok) throw new Error(j.description || j.message || 'Could not update the bag'); return j; }));
  const refresh = () => fetch(`${location.pathname}?section_id=${SECTION}`).then((r) => r.text()).then(render);

  /* Add to bag on the product page */
  const form = document.getElementById('buy-form');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const btns = document.querySelectorAll('[data-add], [data-bar-add]');
      btns.forEach((b) => { b.dataset.label = b.textContent; b.disabled = true; b.textContent = 'Adding…'; });
      const fd = new FormData(form);
      post('/cart/add.js', { items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }] })
        .then((j) => { render(j.sections && j.sections[SECTION]); open(); })
        .catch((err) => alert(err.message))
        .finally(() => btns.forEach((b) => { b.disabled = false; b.textContent = b.dataset.label; }));
    });
  }

  document.addEventListener('click', (e) => {
    const bag = e.target.closest('.site-head__bag');
    if (bag) { e.preventDefault(); refresh().then(open); return; }
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    const q = e.target.closest('[data-cd-qty]');
    if (q) {
      q.disabled = true;
      post('/cart/change.js', { line: Number(q.dataset.cdQty), quantity: Number(q.dataset.q) }).then((j) => render(j.sections && j.sections[SECTION])).catch(() => refresh());
      return;
    }
    const a = e.target.closest('[data-cd-add]');
    if (a) {
      a.disabled = true;
      post('/cart/add.js', { items: [{ id: Number(a.dataset.cdAdd), quantity: 1 }] }).then((j) => render(j.sections && j.sections[SECTION])).catch(() => refresh());
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
})();
